export default () => ({
    loading: false,
    accounts: []
})